import api, { handleApiError } from './api';

export const getUserProfile = async () => {
  try {
    const response = await api.get('/auth/me');
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return { success: false, error: handleApiError(error) };
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.put('/auth/change-password', {
      currentPassword,
      newPassword
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error changing password:', error);
    return { success: false, error: handleApiError(error) };
  }
};

export const updateUserPreferences = async (preferences) => {
  try {
    const response = await api.put('/auth/preferences', preferences);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error updating preferences:', error);
    return { success: false, error: handleApiError(error) };
  }
};
